var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    attrs: {
      "accept-charset": "UTF-8",
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage),
      expression: "successMessage"
    }],
    staticClass: "alert alert-success"
  }, [_vm._v("\n      " + _vm._s(_vm.successMessage) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Customer ID",
      "name": "username",
      "type": "text",
      "required": "",
      "min": "1",
      "pattern": "[0-9]+",
      "disabled": _vm.disableAllInputs,
      "oninvalid": "setCustomValidity('Numeric Customer ID required (not your name or email). Spaces and non-numeric characters are not allowed')",
      "oninput": "setCustomValidity('')"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "submit",
      "value": "Reset Password",
      "disabled": _vm.protectedUI || !_vm.formIsValid || _vm.disableAllInputs
    }
  })])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0149b132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ForgotPassword.vue
// module id = Poyw
// module chunks = 1